import { DEFAULT_DEMO_USER_ID, DEMO_USERS_WITH_CREDENTIALS } from '../constants/demoUsers';

const findDemoUser = (userId: string) =>
    DEMO_USERS_WITH_CREDENTIALS.find(userWithCredentials => userWithCredentials.authInfo.id === userId);

export function getDemoUserWithCredentials(userId: string = DEFAULT_DEMO_USER_ID) {
    return findDemoUser(userId) ?? findDemoUser(DEFAULT_DEMO_USER_ID)!;
}
